import React, { useEffect, useState } from "react";
import { AutoComplete } from "primereact/autocomplete";
import 'primeicons/primeicons.css';
import { useGlobalSearchAdmission } from "../../../hooks/workOrder/useGlobalSearchAdmission";
import '../workOrder/StyleGlobalSearchAdmission.css';
import { Layers } from 'react-feather';
import ReactDOM from "react-dom";

export const GlobalSearchAdmission = ({ handleChangePatient, handleChangeDoctor, idDoctorSelect, handleSelectExamChange, handleCreatePatient, handleCreateDoctor, id_patient, isEditWorkOrder, _config_dashboard, validate_actions, allExams, loadingEditWorkOrder, checkTypeClient, id_company, idAgreementCompany }) => {

  const {
    value,
    setValue,
    resultsSearch,
    searchGlobal,
    counts,
    loading,
    setPendingSelection,
    pendingSelection,
    setShowConfirm,
    showConfirm,
    parsePatient,
    parseDoctor,
    parseExamProfile,
    autoCompleteRef,
    syncOverlayPanel,
    overlayPanel,
    setOverlayPanel,
    setResultsSearch,
    resetSearch
  } = useGlobalSearchAdmission();


  let _active_assignStudies = localStorage.getItem('active_assignStudies');
  console.log("🚀 ~ GlobalSearchAdmission ~ _active_assignStudies:", _active_assignStudies)
  console.log("🚀 ~ GlobalSearchAdmission ~ isEditWorkOrder:", isEditWorkOrder)



  const sidebarOpen =
    localStorage.getItem("sidebartoggle") === "true";

  document.body.classList.toggle(
    "sidebar-open",
    sidebarOpen
  );
  const [showCreateMenu, setShowCreateMenu] = useState(false);

  const [showFilterMenu, setShowFilterMenu] = useState(false);

  const isMobile =
    window.matchMedia(
      "(hover: none) and (pointer: coarse)"
    ).matches;

  const hasPatientSelected = id_patient !== 0;

  const handleCreatePatientClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setShowCreateMenu(false);

    resetSearch();

    if (handleCreatePatient) {
      handleCreatePatient();
    }
  };

  const handleCreateDoctorClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setShowCreateMenu(false);

    resetSearch();

    if (handleCreateDoctor) {
      handleCreateDoctor();
    }
  };

  const confirmChange = () => {
    if (!pendingSelection) return;

    if (pendingSelection.type === "patient") {
      handleSelectPatient(pendingSelection.data);
    }

    setPendingSelection(null);
    setShowConfirm(false);
  };





  const shouldHideExams =
    isEditWorkOrder &&
      _active_assignStudies !== "True"
      ? true
      : (
        (_config_dashboard === "True" && validate_actions === "true") ||
        allExams
      );
  console.log("🚀 ~ GlobalSearchAdmission ~ shouldHideExams:", shouldHideExams)

  const hadExams = resultsSearch.some(item =>
    item.type === "exam" || item.type === "profile"
  );
  //#region FILTER SEARCH
  const [selectedFilter, setSelectedFilter] = useState("all");

  const changeFilter = (filter) => {

    if (selectedFilter === filter) return;

    const hasText =
      typeof value === "string" &&
      value.trim().length > 0;

    setSelectedFilter(filter);

    if (!hasText) return;

    requestAnimationFrame(() => {

      const input =
        autoCompleteRef.current?.inputEL ||
        document.querySelector(
          ".custom-autocomplete-new input"
        );

      if (input) {
        input.focus();
      }

      if (
        autoCompleteRef.current &&
        autoCompleteRef.current.show
      ) {
        autoCompleteRef.current.show();
      }

    });
  };


  //#endregion
  const filteredResults = (() => {

    let base = resultsSearch.filter(item => {

      // SOLO PACIENTES
      if (
        selectedFilter === "patients" &&
        item.type !== "patient" &&
        !item.isGroup &&
        !item.isMessage
      ) {
        return false;
      }

      // SOLO MÉDICOS
      if (
        selectedFilter === "doctors" &&
        item.type !== "doctor" &&
        !item.isGroup &&
        !item.isMessage
      ) {
        return false;
      }
      if (
        selectedFilter === "patients" &&
        item.isGroup &&
        item.group_name !== "Pacientes"
      ) {
        return false;
      }

      if (
        selectedFilter === "doctors" &&
        item.isGroup &&
        item.group_name !== "Doctores"
      ) {
        return false;
      }


      if (isEditWorkOrder && (
        item.type === "patient" ||
        (item.isGroup && item.group_name === "Pacientes")
      )) {
        return false;
      }

      if (shouldHideExams && (
        item.type === "exam" ||
        item.type === "profile" ||
        (item.isGroup && item.group_name === "Estudios")
      )) {
        return false;
      }

      if (item.isMessage) return true;

      if (!hasPatientSelected) {
        if (item.isGroup && item.group_name === "Pacientes") return true;
        if (item.type === "patient") return true;
        return false;
      }

      return true;
    });

    if (isEditWorkOrder === true && _active_assignStudies !== "True") {
      base.unshift({
        isMessage: true,
        isAllReported: true,
        message: "No se pueden anexar estudios, es necesario generar una nueva orden"
      });
    }

    if (shouldHideExams && hadExams && base.length === 0) {
      base.unshift({
        isMessage: true,
        isAllReported: true,
        message: "Todos los estudios ya se encuentran reportados , ya no sera posible agregar más estudios"
      });
    }



    if (!hasPatientSelected) {
      base.unshift({
        isMessage: true,
        isWarning: true,
        message: "Selecciona un paciente para ver médicos y estudios"
      });
    }
    const hasSearchText =
      typeof value === "string" &&
      value.trim().length > 0;

    if (
      hasSearchText &&
      base.length === 0 &&
      (
        selectedFilter === "patients" ||
        selectedFilter === "doctors"
      )
    ) {

      const filterName =
        selectedFilter === "patients"
          ? "pacientes"
          : "médicos";

      base.unshift({
        isMessage: true,
        isEmptyFilter: true,
        message: `No se encontraron resultados con el filtro de ${filterName}`
      });
    }

    return base;

  })();

  const handleSelectPatient = (selected) => {

    handleChangePatient({
      target: {
        name: "id_patient",
        value: selected.id_component
      }
    });

    if (!showConfirm) {
      setValue("");
    }
  };


  const renderItem = (item) => {

    if (item.type === "patient" && isEditWorkOrder) {
      return null;
    }

    if (item.isMessage) {
      return (
        <div
          className={`search-banner 
            ${item.isAllReported ? "success" : ""}
            ${item.isWarning ? "warning" : ""}
            ${item.isEmptyFilter ? "empty-filter" : ""}
          `}
        >
          <i
            className={
              item.isAllReported
                ? "fa fa-check-circle"
                : item.isWarning
                  ? "pi pi-exclamation-triangle"
                  : item.isEmptyFilter
                    ? "pi pi-filter"
                    : "pi pi-search"
            }
          ></i>

          <span>{item.message}</span>
        </div>
      );
    }



    if (item.isGroup) {
      const getIcon = (name) => {
        if (name.includes("Pacientes")) return "pi pi-users";
        if (name.includes("Doctores")) return "fa fa-user-md";
        if (name.includes("Estudios")) return "fa fa-flask";
        return "pi pi-th-large";
      };

      const getCount = () => {
        if (item.group_name === "Pacientes") return counts.patients;
        if (item.group_name === "Doctores") return counts.doctors;
        if (item.group_name === "Estudios") return counts.exams + counts.profiles;
        return 0;
      };

      return (
        <div className="group-header-ios">
          <div className="group-header-left">
            <div className={`group-icon-container ${item.group_name.toLowerCase()}`}>
              <i className={getIcon(item.group_name)}></i>
            </div>
            <span className="group-title-admission">{item.group_name}</span>
          </div>
          <div className="group-header-right">
            <span className="result-badge">
              {getCount()} resultados
            </span>
          </div>
        </div>
      );
    }

    if (item.type === "patient") {
      const data = parsePatient(item.component);
      const isFemale = data.sexo.includes("fem");

      return (
        <div className={`item patient ${isFemale ? "card-patientAdmissionF" : "card-patientAdmissionM"} `} >
          <div className={`item-icon patient-icon ${isFemale ? "female" : "male"}`}>
            <i className="pi pi-user"></i>
          </div>

          <div className="item-text">
            <div className="item-title-patient">
              {data.nombre}
            </div>

            <div className="item-sub">
              <span className={`patient-gender ${isFemale ? "female" : "male"}`}>
                {isFemale ? "Femenino" : "Masculino"}
              </span>

              <span className={`patient-age`}>
                <i className="fa fa-calendar fa-1 mr-1" style={{ color: "#0a8ee6e3" }}></i>
                F.N:{data.birthday}
              </span>

              <span className={`patient-age ${isFemale ? "female" : "male"}`}>
                <i className="fa fa-birthday-cake fa-1 mr-1" style={{ color: "#0a8ee6e3" }}></i>
                Edad: {data.edad}
              </span>
            </div>
          </div>
        </div >
      );
    }

    if (item.type === "doctor") {
      const data = parseDoctor(item.component);

      return (
        <div className="item doctor card-doctorAdmission">
          <div className="item-icon">
            <i className="fa fa-stethoscope"></i>
          </div>

          <div className="doctor-content">
            <div className="doctor-header">
              <span className="doctor-badge">
                {data.especialidad}
              </span>


              {/* <div className="doctor-subline"> */}
              <span className="doctor-info">
                <i className="fa fa-file-text-o fa-1 mr-1" style={{ color: "#16a34a" }}></i>
                <b>OTS: {data.ots}</b>
              </span>

              <span className="doctor-info">
                <i className="fa fa-user-md fa-1 mr-1" style={{ color: "#16a34a" }}></i>
                <b>NC: {data.codigo}</b>
              </span>
              {/* </div> */}


            </div>
            <span className="doctor-name">
              {data.nombre}
            </span>

          </div>
        </div>
      );
    }

    if (item.type === "exam" || item.type === "profile") {
      const data = parseExamProfile(item.component);

      return (
        <div className="item exam card-examAdmission">
          <div className="item-icon exam-icon">
            {data.type === "PERFIL" ? (
              <Layers size={16} />
            ) : (
              <i className="fa fa-flask"></i>
            )}
          </div>

          <div className="exam-content">
            <div className="exam-header">
              <div className="badge-abbreviation">
                {data.abbreviation}
              </div>

              <div className="exam-type">
                <span className={`type ${data.type.toLowerCase()}`}>
                  {data.type}
                </span>
              </div>
            </div>

            <div className="item-title-exam-profiles">
              {data.name}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="item exam">
        <div className="item-icon">
          <i className="pi pi-file"></i>
        </div>

        <div className="item-text">
          <div className="item-title-exam-profiles">{item.component}</div>
        </div>
      </div>
    );
  };


  const footerContent = (
    <div className={showConfirm ? "footer-confirm-mode" : "footer-ios"}>
      {!showConfirm ? (
        <>

          <div className="footer-actions-ios">
            <div className="footer-title-ios">DAR DE ALTA</div>
            {
              !isEditWorkOrder && <button className="footer-btn-ios" onClick={handleCreatePatientClick}>
                Paciente
              </button>
            }


            <button className="footer-btn-ios" onClick={handleCreateDoctorClick}>
              Médico
            </button>
          </div>
        </>
      ) : (

        <div className="confirm-card">

          <div className="confirm-header">
            <div className="confirm-icon">!</div>

            <div className="confirm-texts">
              <div className="confirm-title">
                ¿Cambiar paciente activo?
              </div>

              <div className="confirm-sub">
                Estás seleccionando a{" "}
                <strong>{pendingSelection?.data?.component?.split(" - ")[0]}</strong>
              </div>
            </div>
          </div>

          <div className="confirm-actions">
            <button className="btn-confirm" onClick={confirmChange}>
              CONFIRMAR CAMBIO
            </button>

            <button
              className="btn-cancel"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={() => {
                setShowConfirm(false);

                setTimeout(() => {
                  autoCompleteRef.current.show();
                }, 0);
              }}
            >
              CANCELAR
            </button>
          </div>

        </div>
      )}
    </div>
  );

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "k") {
        e.preventDefault();

        const input = document.querySelector(".custom-autocomplete-new input");
        if (input) {
          input.focus();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  // ! EDIT ORDER LOADING EFFECT
  const [loadingText, setLoadingText] = useState("Cargando orden");

  useEffect(() => {
    if (!loadingEditWorkOrder) return;

    let dots = 0;

    const interval = setInterval(() => {
      dots = (dots + 1) % 4;
      setLoadingText("Cargando orden" + ".".repeat(dots));
    }, 400);

    return () => clearInterval(interval);
  }, [loadingEditWorkOrder]);

  const blockSearch =
    !isEditWorkOrder &&
    checkTypeClient === 3 &&
    (
      !id_company?.value ||
      !idAgreementCompany?.value
    );


  const dynamicPlaceholder = (() => {
    if (blockSearch) {
      return "Seleccione empresa y convenio";
    }

    if (loadingEditWorkOrder) {
      return loadingText;
    }

    if (loadingEditWorkOrder) {
      return loadingText;
    }

    if (selectedFilter === "patients") {
      return "Buscar pacientes...";
    }

    if (selectedFilter === "doctors") {
      return "Buscar médicos...";
    }

    return isEditWorkOrder
      ? "Buscar médicos o estudios..."
      : "Buscar pacientes, médicos y estudios...";
  })();


  useEffect(() => {
    setValue("");
    setResultsSearch([]);
  }, [checkTypeClient]);

  const filterOptions = [
    {
      key: "all",
      icon: "pi pi-search",
      className: "search",
      label: "Todos",
      title: "Traer todos los resultados"
    },

    ...(!isEditWorkOrder
      ? [{
        key: "patients",
        icon: "pi pi-users",
        className: "patients",
        label: "Filtar Pacientes",
        title: "Filtrar por pacientes"
      }]
      : []),

    {
      key: "doctors",
      icon: "fa fa-stethoscope",
      className: "doctors",
      label: "Filtar Médicos",
      title: "Filtrar por médicos"
    }
  ];

  return (
    <div className={`search-container-full  admission-search ${isEditWorkOrder ? "edit-mode" : ""} ${checkTypeClient === 3 ? "with-create" : "without-create"}`}>
      <div className="search-filters-left">
        {
          checkTypeClient === 3 ?
            <div className="create-wrapper">

              <button
                type="button"
                className="filter-pill add"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                disabled={
                  (isEditWorkOrder && loadingEditWorkOrder) ||
                  blockSearch
                }
                onClick={() => {
                  setShowFilterMenu(false);
                  setShowCreateMenu(v => !v);
                }}
                title="Dar de alta paciente y médicos"
              >
                <i className="pi pi-plus"></i>
              </button>

              {showCreateMenu && (
                <div className="floating-create-menu">

                  {!isEditWorkOrder && (
                    <button
                      onClick={(e) => {
                        handleCreatePatientClick(e);
                        setShowCreateMenu(false);
                      }}
                    >
                      <i className="pi pi-user"></i>
                      Paciente
                    </button>
                  )}

                  <button
                    onClick={(e) => {
                      handleCreateDoctorClick(e);
                      setShowCreateMenu(false);
                    }}
                  >
                    <i className="fa fa-stethoscope"></i>
                    Médico
                  </button>

                </div>
              )}

            </div>
            : null

        }

        {isMobile ? (

          <div className="filter-menu-wrapper">

            <button
              type="button"
              disabled={
                (isEditWorkOrder && loadingEditWorkOrder) ||
                blockSearch}
              className={`filter-pill ${filterOptions.find(
                x => x.key === selectedFilter
              )?.className || "search"
                } active`}
              onClick={() => {
                setShowCreateMenu(false);
                setShowFilterMenu(v => !v);
              }}

            >
              <i
                className={
                  filterOptions.find(
                    x => x.key === selectedFilter
                  )?.icon
                }
              />
            </button>

            {showFilterMenu && (
              <div className="floating-filter-menu">

                {filterOptions.map(filter => (
                  <button
                    key={filter.key}
                    className={
                      selectedFilter === filter.key
                        ? "active"
                        : ""
                    }
                    onClick={() => {

                      changeFilter(filter.key);

                      setShowFilterMenu(false);

                    }}
                  >
                    <i className={filter.icon}></i>
                    <span>{filter.label}</span>
                  </button>

                ))}

              </div>
            )}

          </div>

        ) : (

          filterOptions.map(filter => (

            <button
              key={filter.key}
              type="button"
              className={`filter-pill ${filter.className}
                        ${selectedFilter === filter.key
                  ? "active"
                  : ""
                }`}
              disabled={
                (isEditWorkOrder &&
                  loadingEditWorkOrder) ||
                blockSearch
              }
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={() =>
                changeFilter(filter.key)
              }
              title={filter.title}
            >
              <i className={filter.icon}></i>
            </button>
          ))
        )}

      </div>
      <div className="autocomplete-wrapper">

        <AutoComplete
          ref={autoCompleteRef}
          suggestions={
            loading
              ? [{ isMessage: true, message: "Buscando..." }]
              : filteredResults
          }
          panelClassName={`custom-panel-new ${showConfirm ? "blocked" : ""}`}
          className={`custom-autocomplete-new ${loadingEditWorkOrder ? "loading-input" : ""}`}
          value={value}
          completeMethod={searchGlobal}
          field="component"
          placeholder={dynamicPlaceholder}
          onChange={(e) => setValue(e.value)}
          appendTo="self"
          disabled={
            (isEditWorkOrder && loadingEditWorkOrder) ||
            blockSearch
          }
          itemTemplate={(item) => (
            <div className={showConfirm ? "item-disabled" : ""}>
              {renderItem(item)}
            </div>
          )}
          onShow={syncOverlayPanel}
          onHide={() => {
            if (showConfirm) return;
            setOverlayPanel(null);
          }}

          onBlur={() => {
            if (
              document.activeElement &&
              typeof document.activeElement.blur === "function"
            ) {
              document.activeElement.blur();
            }
          }}

          onSelect={(e) => {
            const selected = e.value;
            setValue("");

            if (selected?.type === "patient" && hasPatientSelected) {

              setPendingSelection({
                type: "patient",
                data: selected
              });
              // setValue(""); 
              setShowConfirm(true);

              return;
            }

            if (document.activeElement) {
              document.activeElement.blur();
            }

            setTimeout(() => {
              if (
                autoCompleteRef.current &&
                autoCompleteRef.current.hide
              ) {
                autoCompleteRef.current.hide();
              }
            }, 100);

            if (showConfirm) return;


            if (selected?.type === "patient") {

              if (hasPatientSelected) {
                setPendingSelection({ type: "patient", data: selected });

                setValue("");

                setShowConfirm(true);
                return;
              }
              if (selected?.type === "patient") {

                setResultsSearch([]);

                if (hasPatientSelected) {
                  setPendingSelection({ type: "patient", data: selected });

                  setValue("");
                  setShowConfirm(true);
                  return;
                }

                handleSelectPatient(selected);
              }

              handleSelectPatient(selected);
            }

            else if (selected?.type === "doctor") {
              const data = parseDoctor(selected.component);

              // setValue(data.nombre);

              if (handleChangeDoctor) {

                const newDoctor = {
                  value: selected.id_component,
                  label: data.nombre
                };

                const updatedDoctors = [
                  ...(idDoctorSelect || []),
                  newDoctor
                ];



                handleChangeDoctor({
                  target: {
                    name: "id_doctor",
                    value: updatedDoctors
                  }
                });
              }

              setTimeout(() => setValue(""), 300);
            }

            else if (selected?.type === "exam" || selected?.type === "profile") {

              const value = `${selected.id_component}-${selected.type === "exam" ? 0 : 1}`;

              handleSelectExamChange({
                target: {
                  name: "id_profileExam",
                  value: value
                }
              });

              // setValue("");
            }
          }}
        // disabled={isEditWorkOrder && loadingEditWorkOrder}
        />
        <div className="shortcut-hint">
          <span>CTRL</span>
          <span>K</span>
        </div>
      </div>

      {overlayPanel && ReactDOM.createPortal(footerContent, overlayPanel)}

      {/* EJEMPLO DE SOLO MOVIL */}
      {/* <div className="mobile-only">
        búsqueda por voz
      </div> */}

    </div >
  );
};